import React from 'react';
import styled from 'styled-components';

const EmptySection = styled.div`
height: 100px;
background: ${({ color }) => (color)};
`;

const EmptySpace = ({ color }) => (
  <EmptySection color={color} />
);

export default EmptySpace;
